export type HandoverReloadState = { attempt: number; conflict: boolean; confirming: boolean };
export const initialHandoverReloadState: HandoverReloadState = { attempt: 0, conflict: false, confirming: false };
type Action = "conflict" | "request" | "cancel" | "confirm" | "loaded" | "retryInitialLoad";

/** A revision conflict never starts a reload; replacing local edits requires confirmation. */
export function handoverReloadReducer(state: HandoverReloadState, action: Action): HandoverReloadState {
    switch (action) {
        case "conflict": return { ...state, conflict: true };
        case "request": return state.conflict ? { ...state, confirming: true } : state;
        case "cancel": return { ...state, confirming: false };
        case "confirm": return state.confirming ? { ...state, attempt: state.attempt + 1, confirming: false } : state;
        case "loaded": return { ...state, conflict: false, confirming: false };
        case "retryInitialLoad": return { ...state, attempt: state.attempt + 1 };
    }
}
